import { useFormik } from "formik"
import React, {useState} from "react"
import { useDispatch } from "react-redux"
import * as Yup from "yup"

import { Col, Input, Label, Form, FormFeedback } from "reactstrap"

import { userpasswordchange } from "store/actions"

const ChangePassword = ({ handleCancel,email,toggle }) => {
    const dispatch = useDispatch()
    const [showCurrent, setShowCurrent] = useState(false)
    const [showNew, setShowNew] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            useremail: email,
            currentPassword: '',
            newPassword: '',
            confirmnewPassword: '',
        },
        validationSchema: Yup.object({
            // useremail: Yup.string().required("Please enter your Email"),
            currentPassword: Yup.string().required("Please Enter Your Current Password").min(6, "Current Password must be at least 6 characters"),
            newPassword: Yup.string().required("Please Enter Your New Password").min(6, 'New Password must be at least 6 characters'),
            confirmnewPassword: Yup.string()
                .oneOf([Yup.ref("newPassword"), null], "Passwords don't match!")
                .required("Please Enter Your Verify Password"),
        }),
        onSubmit: (values) => {
            const value = {
                userEmail: values?.useremail,
                currentPassword: values?.currentPassword,
                newPassword: values?.newPassword,
            }
            dispatch(userpasswordchange(value,handleResponse));
        }
    });
    const handleResponse = (status) => {
        if(status === 'SUCCESS'){
          toggle();
          validation.resetForm();
        }
      }

    return (
        <Form
            onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
            }}
        >
            <Col md="12" className="mt-2 mb-2">
                <div className="mb-3">
                    <Label for="useremail" className="form-label">
                        Email
                    </Label>
                    <Input
                        name="useremail"
                        classuseremail="form-control"
                        placeholder="Enter Your Email"
                        type="email"
                        disabled={true}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.useremail || ""}
                        invalid={
                            validation.touched.useremail &&
                                validation.errors.useremail
                                ? true
                                : false
                        }
                    />
                    {validation.touched.useremail &&
                        validation.errors.useremail ? (
                        <FormFeedback type="invalid">
                            {validation.errors.useremail}
                        </FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3" style={{ position: "relative" }}>
                    <Label className="form-label"> Current Password</Label>
                    <Input
                        name="currentPassword"
                        className="form-control"
                        placeholder="Old Password"
                        type={showCurrent ? "text" : "password"}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.currentPassword || ""}
                        invalid={
                            validation.touched.currentPassword && validation.errors.currentPassword ? true : false
                        } />

                    {validation.touched.currentPassword && validation.errors.currentPassword ? (
                        <FormFeedback type="invalid">{validation.errors.currentPassword}</FormFeedback>
                    ) : null}
                     <i
                        className={`fa ${showCurrent ? "fa-eye" : "fa-eye-slash"}`}
                        onClick={() => setShowCurrent(!showCurrent)}
                        style={{
                        position: "absolute",
                        right: "39px",
                        top: "42px",
                        cursor: "pointer",
                        color: "orange"
                        }}
                    />
                </div>
                <div className="mb-3" style={{ position: "relative" }}>
                    <Label className="form-label"> New Password</Label>
                    <Input
                        name="newPassword"
                        className="form-control"
                        placeholder="New Password"
                        type={showNew ? "text" : "password"}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.newPassword || ""}
                        invalid={
                            validation.touched.newPassword && validation.errors.newPassword ? true : false
                        } />

                    {validation.touched.newPassword && validation.errors.newPassword ? (
                        <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                    ) : null}
                     <i
                        className={`fa ${showNew ? "fa-eye" : "fa-eye-slash"}`}
                        onClick={() => setShowNew(!showNew)}
                        style={{
                        position: "absolute",
                        right: "39px",
                        top: "42px",
                        cursor: "pointer",
                        color: "orange"
                        }}
                    />
                </div>

                <div className="mb-3" style={{ position: "relative" }}>
                    {/* <Label className="form-label">Enter Your New Password</Label> */}
                    <Input
                        name="confirmnewPassword"
                        className="form-control"
                        placeholder="Confirm New Password"
                        type={showConfirm ? "text" : "password"}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.confirmnewPassword || ""}
                        invalid={
                            validation.touched.confirmnewPassword && validation.errors.confirmnewPassword ? true : false
                        } />

                    {validation.touched.confirmnewPassword && validation.errors.confirmnewPassword ? (
                        <FormFeedback type="invalid">{validation.errors.confirmnewPassword}</FormFeedback>
                    ) : null}
                     <i
                        className={`fa ${showConfirm ? "fa-eye" : "fa-eye-slash"}`}
                        onClick={() => setShowConfirm(!showConfirm)}
                        style={{
                        position: "absolute",
                        right: "39px",
                        top: "12px",
                        cursor: "pointer",
                        color: "orange"
                        }}
                    />
                </div>
            </Col>

            <div className="text-end">
                <button
                    type="submit"
                    className="btn btn-primary save-customer me-2"
                >
                    Save
                </button>
                <button
                    type="button"
                    color="primary"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                >
                    Cancel
                </button>
            </div>
        </Form>
    )
}

export default ChangePassword
